import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color='currentColor', customClass = '' }: IconComponentProps) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' class={customClass}>
    <path d='M7 10L12 15L17 10H7Z' fill={color} />
  </svg>
)
